import { FC, SVGProps } from "react";

interface ChatIconProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

const ChatIcon: FC<ChatIconProps> = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.66016 10.3711C1.96224 9.1936 1.71812 7.80185 1.97362 6.45712C2.22912 5.11239 2.96668 3.90716 4.04783 3.06769C5.12897 2.22822 6.47936 1.81225 7.84546 1.89786C9.21157 1.98348 10.4995 2.56479 11.4673 3.53267C12.4352 4.50055 13.0165 5.78843 13.1021 7.15454C13.1878 8.52065 12.7718 9.87103 11.9323 10.9522C11.0928 12.0333 9.88762 12.7709 8.54289 13.0264C7.19816 13.2819 5.80641 13.0378 4.62891 12.3398V12.3398L2.6836 12.8906C2.6039 12.9139 2.51939 12.9154 2.43895 12.8948C2.3585 12.8742 2.28506 12.8324 2.22635 12.7737C2.16763 12.7149 2.12579 12.6415 2.10521 12.5611C2.08463 12.4806 2.08607 12.3961 2.10938 12.3164L2.66016 10.3711Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 8.20312C7.88833 8.20312 8.20312 7.88833 8.20312 7.5C8.20312 7.11167 7.88833 6.79688 7.5 6.79688C7.11167 6.79688 6.79688 7.11167 6.79688 7.5C6.79688 7.88833 7.11167 8.20312 7.5 8.20312Z"
        fill="black"
      />
      <path
        d="M4.6875 8.20312C5.07583 8.20312 5.39062 7.88833 5.39062 7.5C5.39062 7.11167 5.07583 6.79688 4.6875 6.79688C4.29917 6.79688 3.98438 7.11167 3.98438 7.5C3.98438 7.88833 4.29917 8.20312 4.6875 8.20312Z"
        fill="black"
      />
      <path
        d="M10.3125 8.20312C10.7008 8.20312 11.0156 7.88833 11.0156 7.5C11.0156 7.11167 10.7008 6.79688 10.3125 6.79688C9.92417 6.79688 9.60938 7.11167 9.60938 7.5C9.60938 7.88833 9.92417 8.20312 10.3125 8.20312Z"
        fill="black"
      />
    </svg>
  );
};

export default ChatIcon;
